import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { useCurrentUser } from '../../../../shared/store-user.hooks';
import { WorkshopSession } from '../../../../types/workshop.types';
import { buildMatch } from '../../../../utils/filter.utils';
import RegistrationConditionMessage from '../../../../workshops/components/RegistrationConditionMessage';
import { meetsRegistrationCondition } from '../../../../workshops/utils/registrationConditionUtils';
import { SessionButton } from './SessionButton';

type SessionsButtonProps = {
  workshop: any;
  filter: string;
  options: any;
};

const SessionsButton: FC<SessionsButtonProps> = (props) => {
  const { workshop, options = {}, ...rest } = props;
  const { sessions } = workshop;
  const { filter } = options;
  const filterMatch = buildMatch(filter);
  const filteredSessions = (sessions || []).filter(filterMatch);

  const registrations = useSelector((state: any) => state.registrations.registrationsBySessionId);
  const registeredSession = (sessions || []).find((s: WorkshopSession) => !!registrations[s._id]);

  const user = useCurrentUser();
  // Sessions the user cannot register to are hidden, unless already registered
  const allowedSessions = filteredSessions.filter(
    (session: WorkshopSession) =>
      !!registrations[session._id] || meetsRegistrationCondition(session, user),
  );

  if (filteredSessions.length > 0 && allowedSessions.length === 0) {
    return <RegistrationConditionMessage />;
  }

  return (
    <>
      {allowedSessions.map((session: WorkshopSession) => (
        <SessionButton
          key={session._id}
          session={session}
          registeredSession={registeredSession}
          options={options}
          {...rest}
        />
      ))}
    </>
  );
};

export { SessionsButton };
